import React from 'react';

import * as S from './styles';

// recreating this so we could remove the old dls dependency for this SVG wrapper component
export const SVG = ({ src, fill, hoverColor, style }) => (
  <S.SvgWrapper
    fill={fill}
    hoverColor={hoverColor}
    style={style}
    dangerouslySetInnerHTML={{
      __html: src,
    }}
  />
);

export const SubHeaderNavLink = ({ link, secondary }) => (
  <S.LinkWrapper secondary={secondary}>
    <S.SubHeaderLink to={link.url}>
      {link.icon && <SVG src={link.icon} style={{ height: '24px' }} />}
      <S.LinkText>{link.label}</S.LinkText>
    </S.SubHeaderLink>
  </S.LinkWrapper>
);

export default SubHeaderNavLink;
